/**
 * JKL Newsletter consent
 *
 * Shared by the footer newsletter (jkl-footer) and the newsletter snippet (jkl-newsletter).
 * Applies to every form with [data-newsletter-consent]:
 * - shows the consent checkboxes (.footer__newsletter-consent) once a valid email is typed
 * - on submit, blocks the submission and shows the error if a required consent checkbox is unchecked
 */

(function () {
  if (window.jklNewsletterConsentInitialized) return;
  window.jklNewsletterConsentInitialized = true;

  function isValidEmail(value) {
    const emailValue = value.trim();
    return (
      emailValue.length > 0 &&
      emailValue.includes("@") &&
      emailValue.includes(".")
    );
  }

  function initNewsletterConsent(form) {
    // Avoid binding listeners twice on the same form
    if (form.dataset.newsletterConsentInitialized) return;
    form.dataset.newsletterConsentInitialized = "true";

    const emailInput = form.querySelector(
      'input[type="email"][name="contact[email]"]',
    );
    const consentSection = form.querySelector(".footer__newsletter-consent");
    if (!emailInput || !consentSection) return;

    const submitButtons = form.querySelectorAll('[type="submit"]');
    const inputWrapper = form.querySelector(".jkl-input-secondary");
    const errorMessageElement = form.querySelector(
      ".jkl-input__message--error",
    );
    const requiredCheckboxes = consentSection.querySelectorAll(
      'input[type="checkbox"][required]',
    );

    // Hide error initially
    if (errorMessageElement) {
      errorMessageElement.style.display = "none";
    }

    function showError() {
      if (inputWrapper) {
        inputWrapper.classList.add("jkl-input--error");
      }

      // Add error class only to unchecked required consent checkboxes
      requiredCheckboxes.forEach((checkbox) => {
        const text = checkbox
          .closest(".footer__consent-checkbox")
          ?.querySelector(".footer__consent-text");
        if (!checkbox.checked && text) {
          text.classList.add("footer__consent-text--error");
        }
      });

      if (errorMessageElement) {
        errorMessageElement.style.display = "block";
        errorMessageElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    function clearError() {
      if (inputWrapper) {
        inputWrapper.classList.remove("jkl-input--error");
      }

      consentSection
        .querySelectorAll(".footer__consent-text")
        .forEach((text) =>
          text.classList.remove("footer__consent-text--error"),
        );

      if (errorMessageElement) {
        errorMessageElement.style.display = "none";
      }
    }

    function checkEmailAndShowConsent() {
      consentSection.classList.toggle(
        "hidden",
        !isValidEmail(emailInput.value),
      );

      // Clear error when user types
      clearError();
    }

    function validateConsent(event) {
      if (
        isValidEmail(emailInput.value) &&
        !consentSection.classList.contains("hidden")
      ) {
        const allChecked = Array.from(requiredCheckboxes).every(
          (checkbox) => checkbox.checked,
        );

        if (!allChecked) {
          event.preventDefault();
          showError();
          return false;
        }
      }

      clearError();
      return true;
    }

    // Show consent checkboxes when email input has valid value
    ["input", "change", "blur", "focus"].forEach((eventName) => {
      emailInput.addEventListener(eventName, checkEmailAndShowConsent);
    });

    // Validate consent on submit (buttons click and keyboard submit)
    submitButtons.forEach((button) =>
      button.addEventListener("click", validateConsent),
    );
    form.addEventListener("submit", validateConsent);

    // Clear error when checkboxes are clicked
    consentSection
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => checkbox.addEventListener("change", clearError));
  }

  function initAll(root) {
    root
      .querySelectorAll("form[data-newsletter-consent]")
      .forEach(initNewsletterConsent);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  // Re-initialize on Shopify theme editor section load/rerender
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
